<template>
        <span>{{ $t(_text) || _text }}</span>
</template>

<script>
export default {
    name: 'Lange',
    props : [ 'text' ],
    data () {
        return { _text: ''}
    },
    mounted(){
        this._text = this.text || this.$slots.default[0].text
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Lang.vue